import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GOOGLE_KEY, GOOGLE_BASE_URL } from './constants';

const MapImg = styled.img`
  width: 100%;
`;

export const StaticMap = React.memo(({ widthCache, pointString }) => {
  const width = Math.round(widthCache / 2 - 12);
  return (
    <div style={{ height: '450px', width, display: 'inline-block' }}>
      <MapImg
        src={`${GOOGLE_BASE_URL}/streetview?size=${width}x450&location=${pointString}&pitch=-0.76&key=${GOOGLE_KEY}`}
        alt="Street View"
      />
      <DateComponent pointString={pointString} />
    </div>
  );
});

const DateComponent = ({ pointString }) => {
  const [date, setDate] = useState('Latest image available.');
  useEffect(() => {
    const fetchMeta = async () => {
      const results = await fetch(
        `${GOOGLE_BASE_URL}/streetview/metadata?location=${pointString}&pitch=-0.76&key=${GOOGLE_KEY}`
      );
      const meta = await results.json();
      if (!meta.date) return;
      setDate(`Image from ${meta.date}`);
    };
    fetchMeta();
  });

  return <small>{date}</small>;
};
